var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"close-button toggle-slider",class:_vm.color},[_c('img',{attrs:{"src":_vm.iconUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }